import React from 'react';
import { Link } from 'react-router-dom';

const Navigation: React.FC = () => {
  // Simpler approach to close the offcanvas menu
  const handleLinkClick = () => {
    if (window.innerWidth < 992) { // Bootstrap lg breakpoint is 992px
      // Use the data-bs-dismiss attribute instead of JS API
      const closeButton = document.querySelector('[data-bs-dismiss="offcanvas"]') as HTMLElement;
      closeButton?.click();
    }
  };

  return (
    <nav className="navbar navbar-expand-lg" style={{ borderBottom: '2px solid #000' }}>
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">Perler med Vilje</Link>

        {/* Responsive Hamburger Menu */}
        <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Offcanvas Menu */}
        <div className="offcanvas offcanvas-end" tabIndex={-1} id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasNavbarLabel">Meny</h5>
            <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
              {/* <li className="nav-item">
                <Link className="nav-link" to="/news" onClick={handleLinkClick}>Nyheter</Link>
              </li> */}
              <li className="nav-item">
                <Link className="nav-link" to="/category/armband" onClick={handleLinkClick}>Håndleddspynt</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/category/orepynt" onClick={handleLinkClick}>Ørepynt</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/category/mobilpynt" onClick={handleLinkClick}>Mobilpynt</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about" onClick={handleLinkClick}>Om PMV</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;